import { RestClient } from "clients/rest";

export type B000011UpdateRequest = {
  ninshoKey: string;
};

export const B000011Update = (props: B000011UpdateRequest) => {
  return RestClient.put("b000011/update", props, {
    withCredentials: true,
  });
};

export const B000011Valid = () => {
  return RestClient.get("b000011/valid", {
    withCredentials: true,
  });
};
